class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.subjectInput = null;
    this.form = null;
    this.nameInput = null;
    this.resetButtons = [];
    this.successState = null;
    this.errorState = null;
    this.onQuestionClick = this.onQuestionClick.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  connectedCallback() {
    this.subjectInput = this.querySelector("[data-contact-subject]");
    this.form = this.querySelector("[data-contact-form]");
    this.fields = this.querySelector("[data-contact-fields]");
    this.nameInput = this.querySelector("[data-contact-name]");
    this.resetButtons = this.querySelectorAll("[data-contact-reset]");
    this.submitButton = this.querySelector("[data-contact-submit]");
    this.submitIdle = this.querySelector('[data-contact-submit-state="idle"]');
    this.submitLoading = this.querySelector(
      '[data-contact-submit-state="loading"]'
    );
    this.successState = this.querySelector("[data-contact-success]");
    this.errorState = this.querySelector("[data-contact-error]");
    this.onSubmit = this.onSubmit.bind(this);
    if (!this.form) return;
    this.addEventListener("click", this.onQuestionClick);
    this.form.addEventListener("submit", this.onSubmit);
    this.resetButtons.forEach((button) => {
      button.addEventListener("click", this.onResetClick);
    });
    this.initDefaultQuestion();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onQuestionClick);
    if (this.form) {
      this.form.removeEventListener("submit", this.onSubmit);
    }
    this.resetButtons.forEach((button) => {
      button.removeEventListener("click", this.onResetClick);
    });
  }

  onQuestionClick(event) {
    const button = event.target.closest("[data-contact-question]");
    if (!button || !this.contains(button)) return;
    if (!this.subjectInput) return;
    this.setActiveQuestion(button);
    this.subjectInput.value = button.dataset.contactQuestion || "";
    this.subjectInput.dispatchEvent(new Event("input", { bubbles: true }));
  }

  initDefaultQuestion() {
    const defaultButton = this.querySelector(
      "[data-contact-question][data-contact-default]"
    );
    if (!defaultButton) return;
    this.setActiveQuestion(defaultButton);
    if (this.subjectInput && this.subjectInput.value.trim() === "") {
      this.subjectInput.value = defaultButton.dataset.contactQuestion || "";
      this.subjectInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  setActiveQuestion(activeButton) {
    const buttons = Array.from(
      this.querySelectorAll("[data-contact-question]")
    );
    buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.dataset.active = isActive ? "true" : "false";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  onSubmit() {
    if (this.subjectInput && this.subjectInput.value.trim() === "") {
      this.subjectInput.disabled = true;
    }
    if (!this.submitButton) return;
    this.submitButton.disabled = true;
    if (this.submitIdle) {
      this.submitIdle.classList.add("hidden");
    }
    if (this.submitLoading) {
      this.submitLoading.classList.remove("hidden");
    }
  }

  onResetClick(event) {
    event.preventDefault();
    if (this.form) {
      this.form.reset();
    }
    if (this.subjectInput) {
      this.subjectInput.disabled = false;
      this.subjectInput.value = "";
      this.subjectInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
    this.initDefaultQuestion();
    if (this.successState) {
      this.successState.classList.add("hidden");
    }
    if (this.errorState) {
      this.errorState.classList.add("hidden");
    }
    if (this.fields) {
      this.fields.classList.remove("hidden");
    }
    if (this.form) {
      this.form.classList.remove("hidden");
    }
    if (this.submitButton) {
      this.submitButton.disabled = false;
    }
    if (this.submitIdle) {
      this.submitIdle.classList.remove("hidden");
    }
    if (this.submitLoading) {
      this.submitLoading.classList.add("hidden");
    }
    if (this.nameInput) {
      this.nameInput.focus();
    }
  }
}

customElements.define("contact-form", ContactForm);
